import { Component, HostBinding, input } from '@angular/core';
import { SvgIconComponent } from "../../svg-icon/svg-icon.component";

@Component({
  selector: 'app-control-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.css'],
  imports: [SvgIconComponent],
})
export class RadioButtonComponent {

  checked = input<boolean>(false)
  disabled = input<boolean>(false)

  @HostBinding('class')
  get cssClass() {
    return this.disabled() ? 'disabled' : (this.checked() ? 'checked' : '')
  }

}
